<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :onFetchData="onFetchData"
    :actions="actions"
    :onFormSubmit="handleSubmit"
    :form="form"
    :title="$t('menu.rulesAndKycs')"
    resource="settings"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Setting extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [];
  }

  get kycColumns() {
    return [
      {
        prop: 'monthly_transaction_limit',
        label: this.$t('setting.monthlyTransactionLimit'),
        renderCell: (h, { props: { value } }) => {
          return <span>{ this.$options.filters.currencyFormat(value) }</span>;
        }
      },
      {
        prop: 'daily_transaction_limit',
        label: this.$t('setting.dailyTransactionLimit'),
        renderCell: (h, { props: { value } }) => {
          return <span>{ this.$options.filters.currencyFormat(value) }</span>;
        }
      },
      {
        prop: 'wallet_balance_limit',
        label: this.$t('setting.walletBalanceLimit'),
        renderCell: (h, { props: { value } }) => {
          return <span>{ this.$options.filters.currencyFormat(value) }</span>;
        }
      },
      {
        prop: 'max_amount_per_red_packet',
        label: this.$t('setting.maxAmountPerRedPacket'),
        renderCell: (h, { props: { value } }) => {
          return <span>{ this.$options.filters.currencyFormat(value) }</span>;
        }
      },
      {
        prop: 'daily_red_packet_created_count_limit',
        label: this.$t('setting.dailyRedPacketCreatedCountLimit'),
        renderCell: (h, { props: { value } }) => {
          return <span>{ this.$options.filters.currencyFormat(value) }</span>;
        }
      },
      {
        prop: 'daily_red_packet_created_amount_limit',
        label: this.$t('setting.dailyRedPacketCreatedAmountLimit'),
        renderCell: (h, { props: { value } }) => {
          return <span>{ this.$options.filters.currencyFormat(value) }</span>;
        }
      },
    ];
  }

  get kycFromColumns() {
    return [
      {
        prop: 'monthly_transaction_limit',
        label: this.$t('setting.monthlyTransactionLimit'),
        renderCell: {
          component: 'inputNumber',
          hint: this.$t('hint.zeroMeansNoLimit'),
          required: true,
          props: {
            min: 0
          }
        }
      },
      {
        prop: 'daily_transaction_limit',
        label: this.$t('setting.dailyTransactionLimit'),
        renderCell: {
          component: 'inputNumber',
          hint: this.$t('hint.zeroMeansNoLimit'),
          required: true,
          props: {
            min: 0
          }
        }
      },
      {
        prop: 'wallet_balance_limit',
        label: this.$t('setting.walletBalanceLimit'),
        renderCell: {
          component: 'inputNumber',
          hint: this.$t('hint.zeroMeansNoLimit'),
          required: true,
          props: {
            min: 0
          }
        }
      },
      {
        prop: 'max_amount_per_red_packet',
        label: this.$t('setting.maxAmountPerRedPacket'),
        renderCell: {
          component: 'inputNumber',
          hint: this.$t('hint.zeroMeansNoLimit'),
          required: true,
          props: {
            min: 0
          }
        }
      },
      {
        prop: 'daily_red_packet_created_count_limit',
        label: this.$t('setting.dailyRedPacketCreatedCountLimit'),
        renderCell: {
          component: 'inputNumber',
          hint: this.$t('hint.zeroMeansNoLimit'),
          required: true,
          props: {
            min: 0
          }
        }
      },
      {
        prop: 'daily_red_packet_created_amount_limit',
        label: this.$t('setting.dailyRedPacketCreatedAmountLimit'),
        renderCell: {
          component: 'inputNumber',
          hint: this.$t('hint.zeroMeansNoLimit'),
          required: true,
          props: {
            min: 0
          }
        }
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      // {
      //   prop: 'customer_service_phone',
      //   label: this.$t('setting.customerServicePhone')
      // },
      {
        prop: 'customer_service_whatsapp',
        label: this.$t('setting.customerServiceWhatsapp')
      },
      {
        prop: 'customer_service_email',
        label: this.$t('setting.customerServicseEmail')
      },
      process.env.VUE_APP_ENV !== 'production' && {
        prop: 'internal_test_account_phones',
        label: this.$t('setting.internalTestAccountPhones'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <span>{ value.join(', ') }</span>;
          }
        }
      },
      {
        prop: 'sms_provider',
        label: this.$t('setting.smsProvider'),
      },
      {
        prop: 'turn_off_sms_notification_platforms',
        label: this.$t('setting.turnOffSmsNotificationPlatforms'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <span>{ value.join(', ') }</span>;
          }
        }
      },
      {
        prop: 'ticket_event_poster',
        label: this.$t('setting.ticketEventPoster') + ' (Deprecated in next APP version)',
        renderCell: 'storageAttachment',
      },
      {
        prop: 'recommended_ticket_event',
        label: this.$t('setting.recommendedTicketEvent') + ' (Deprecated in next APP version)',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link KeepNode to={{ name: 'ticket_events.show', params: { id: value.id } }}>{ value.title }</bean-link>
          }
        }
      },
      {
        prop: 'show_withdrawal_function_suspended_popup',
        label: this.$t('setting.showWithdrawalFunctionSuspendedPopup'),
        renderCell: 'bool'
      },
      {
        prop: 'minimum_transaction_amounts',
        label: this.$t('setting.minimumTransactionAmounts'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-list value={value} columns={[
              {
                prop: 'topup',
                label: this.$t('setting.topup'),
              },
              {
                prop: 'transfer',
                label: this.$t('setting.transfer'),
              },
              {
                prop: 'pay_with_qr_code',
                label: this.$t('setting.payWithQrCode'),
              },
              {
                prop: 'withdraw',
                label: this.$t('setting.withdraw'),
              },
            ]} />;
          }
        }
      },
      {
        prop: 'transfer_amount_multiple',
        label: this.$t('setting.transferAmountMultiple'),
      },
      {
        prop: 'cashback_rules',
        label: this.$t('setting.cashbackRules'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-list value={value} columns={[
              {
                prop: 'sign_up',
                label: this.$t('setting.signUp'),
              },
              {
                prop: 'first_payment',
                label: this.$t('setting.firstPayment')
              },
              {
                prop: 'first_topup',
                label: this.$t('setting.firstTopup')
              },
              {
                prop: 'login_per_day',
                label: this.$t('setting.loginPerDay'),
              },
              {
                prop: 'transfer',
                label: this.$t('setting.transfer')
              },
              {
                prop: 'payment_to_merchants',
                label: this.$t('setting.paymentToMerchants'),
              },
              {
                prop: 'topup_from_mobile_money',
                label: this.$t('setting.topupFromMobileMoney'),
              },
              {
                prop: 'bind_invitor',
                label: this.$t('setting.bindInvitor'),
              },
              {
                prop: 'invited_per_user',
                label: this.$t('setting.invitedPerUser'),
              }
            ]} />
          }
        }
      },
      {
        prop: 'kyc_rules',
        label: this.$t('setting.kycRules'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-list value={value} columns={[
              {
                prop: 'no_kyc',
                label: 'No KYC',
                renderCell: (h, { props: { value } }) => {
                  return <bean-list value={value} columns={this.kycColumns} />
                }
              },
              {
                prop: 'light_kyc',
                label: 'Light KYC',
                renderCell: (h, { props: { value } }) => {
                  return <bean-list value={value} columns={this.kycColumns} />
                }
              },
              {
                prop: 'extended_kyc',
                label: 'Extended KYC',
                renderCell: (h, { props: { value } }) => {
                  return <bean-list value={value} columns={this.kycColumns} />
                }
              },
            ]} />
          }
        }
      },
    ].filter(Boolean);
  }

  async onFetchData() {
    if (this.type === 'edit' || this.type === 'show') {
      const data = await this.$request.get('/settings');
      return {  data }
    }
  }

  async handleSubmit({ data }) {
    try {
      this.formLoading = true;
      let body = data;
      await this.$request.put('/settings', body);
      this.$message.success(this.$t('bean.updateSuccess'));
      this.$router.push({ name: 'settings.show' });
    } finally {
      this.formLoading = false;
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      // {
      //   prop: 'customer_service_phone',
      //   label: this.$t('setting.customerServicePhone'),
      //   renderCell: {
      //     component: 'input',
      //   }
      // },
      {
        prop: 'customer_service_whatsapp',
        label: this.$t('setting.customerServiceWhatsapp'),
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'customer_service_email',
        label: this.$t('setting.customerServicseEmail'),
        renderCell: {
          component: 'input',
        }
      },
      process.env.VUE_APP_ENV !== 'production' && {
        prop: 'internal_test_account_phones',
        label: this.$t('setting.internalTestAccountPhones'),
        renderCell: {
          component: 'select',
          hint: this.$t('setting.internalTestAccountPhonesHint'),
          props: {
            multiple: true,
            filterable: true,
            'allow-create': true,
            placeholder: this.$t('hint.inputPhoneNumber'),
          },
          domProps: {
            style: 'width: 100%',
          }
        }
      },
      {
        prop: 'sms_provider',
        label: this.$t('setting.smsProvider'),
        renderCell: {
          component: 'select',
          required: true,
          props: {
            options: ['Twilio', 'Termii'].map(value => ({ value, label: value })),
          }
        }
      },
      {
        prop: 'turn_off_sms_notification_platforms',
        label: this.$t('setting.turnOffSmsNotificationPlatforms'),
        renderCell: {
          component: 'select',
          hint: this.$t('hint.turnOffSmsNotificationPlatformsHint'),
          props: {
            clearable: true,
            multiple: true,
            options: ['Client APP', 'Agent APP'].map(value => ({ value, label: value })),
          }
        }
      },
      {
        prop: 'ticket_event_poster',
        label: this.$t('setting.ticketEventPoster') + ' (Deprecated in next APP version)',
        renderCell: {
          component: 'upload',
        }
      },
      {
        prop: 'recommended_ticket_event_id',
        label: this.$t('setting.recommendedTicketEvent') + ' (Deprecated in next APP version)',
        renderCell: {
          component: 'select',
          props: {
            filterable: true,
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/ticket_events/read_options');
              return data.map(({ id, title }) => ({ value: id, label: title }));
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/ticket_events/read_options', { params: { keyword } });
              return data.map(({ id, title }) => ({ value: id, label: title }));
            },
          }
        }
      },
      {
        prop: 'show_withdrawal_function_suspended_popup',
        label: this.$t('setting.showWithdrawalFunctionSuspendedPopup'),
        renderCell: {
          component: 'switch',
        }
      },
      {
        prop: 'minimum_transaction_amounts',
        label: this.$t('setting.minimumTransactionAmounts'),
        renderCell: {
          component: 'staticNestForm',
          props: {
            columns: [
              {
                prop: 'topup',
                label: this.$t('setting.topup'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 1,
                    precision: 0,
                  }
                }
              },
              {
                prop: 'transfer',
                label: this.$t('setting.transfer'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 1,
                    precision: 0,
                  },
                }
              },
              {
                prop: 'pay_with_qr_code',
                label: this.$t('setting.payWithQrCode'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 1,
                    precision: 0,
                  }
                }
              },
              {
                prop: 'withdraw',
                label: this.$t('setting.withdraw'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 1,
                    precision: 0,
                  }
                }
              },
            ]
          }
        }
      },
      {
        prop: 'transfer_amount_multiple',
        label: this.$t('setting.transferAmountMultiple'),
        renderCell: {
          component: 'inputNumber',
          required: true,
          props: {
            min: 1,
            precision: 0,
          }
        }
      },
      {
        prop: 'cashback_rules',
        label: this.$t('setting.cashbackRules'),
        renderCell: {
          component: 'staticNestForm',
          props: {
            columns: [
              {
                prop: 'sign_up',
                label: this.$t('setting.signUp'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 0
                  }
                }
              },
              {
                prop: 'first_payment',
                label: this.$t('setting.firstPayment'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 0
                  }
                }
              },
              {
                prop: 'first_topup',
                label: this.$t('setting.firstTopup'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 0
                  }
                }
              },
              {
                prop: 'login_per_day',
                label: this.$t('setting.loginPerDay'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 0
                  }
                }
              },
              {
                prop: 'transfer',
                label: this.$t('setting.transfer'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 0
                  }
                }
              },
              {
                prop: 'payment_to_merchants',
                label: this.$t('setting.paymentToMerchants'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 0
                  },
                  hint: this.$t('setting.paymentToMerchantsHint'),
                }
              },
              {
                prop: 'topup_from_mobile_money',
                label: this.$t('setting.topupFromMobileMoney'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 0
                  }
                }
              },
              {
                prop: 'bind_invitor',
                label: this.$t('setting.bindInvitor'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 0
                  }
                }
              },
              {
                prop: 'invited_per_user',
                label: this.$t('setting.invitedPerUser'),
                renderCell: {
                  component: 'inputNumber',
                  required: true,
                  props: {
                    min: 0
                  }
                }
              }
            ]
          }
        }
      },
      {
        prop: 'kyc_rules',
        label: this.$t('setting.kycRules'),
        renderCell: {
          component: 'staticNestForm',
          props: {
            columns: [
              {
                prop: 'no_kyc',
                label: 'No KYC',
                renderCell: {
                  component: 'staticNestForm',
                  props: {
                    columns: this.kycFromColumns
                  }
                }
              },
              {
                prop: 'light_kyc',
                label: 'Light KYC',
                renderCell: {
                  component: 'staticNestForm',
                  props: {
                    columns: this.kycFromColumns
                  }
                }
              },
              {
                prop: 'extended_kyc',
                label: 'Extended KYC',
                renderCell: {
                  component: 'staticNestForm',
                  props: {
                    columns: this.kycFromColumns
                  }
                }
              },
            ]
          }
        }
      },
    ].filter(Boolean);
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions() {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('update'),
          to: { name: 'settings.edit' }
        }
      }
    ].filter(Boolean);
  }
}


export const route = [
  {
    path: '/settings',
    name: 'settings.show',
    component: Setting,
    props: {
      type: 'show'
    },
    meta: {
      backBtn: false
    }
  },
  {
    path: '/settings/edit',
    name: 'settings.edit',
    component: Setting,
    props: {
      type: 'edit',
    }
  },
]
</script>

<style scoped lang="scss">
  /deep/.admin-static-nest-form {
    .el-form-item {
      margin-bottom: 20px;
    }
  }
</style>
